import { apiErrorCode } from 'src/api/axiosClient/errorHandling';

export const QR_CODE_SAVE_FAILED = 'Could not save the QR code.';

// A refusal over the name and one over the keyword are both 409: only the API's own code says
// which of the two the user has to change.
export function qrCodeSaveMessage(error: unknown, name: string): string {
  switch (apiErrorCode(error)) {
    case 'conflict':
      return `A QR code of this type is already named "${name}".`;
    case 'qrcode_keyword_taken':
      return 'This keyword already has a QR code. Archive that one before saving this.';
    default:
      return QR_CODE_SAVE_FAILED;
  }
}
